import moment from 'moment';
module.exports = {
  DateTimeFormatter(date) {
    let fecha = new Date(date);
    let fecha_str = "";

    let dia = fecha.getDate();
    if (dia < 10) fecha_str += "0" + dia;
    else fecha_str += dia;

    fecha_str += "/";

    let month = fecha.getMonth();
    if (month < 10) fecha_str += "0" + month;
    else fecha_str += month;

    fecha_str += "/";

    let Year = fecha.getFullYear();
    fecha_str += Year;
    fecha_str += " ";

    let Hour = fecha.getHours();
    if (Hour < 10) fecha_str += "0" + Hour;
    else fecha_str += Hour;

    fecha_str += ":";

    let Minutes = fecha.getMinutes();
    if (Minutes < 10) fecha_str += "0" + Minutes;
    else fecha_str += Minutes;

    return fecha_str;
  },
  DateFormatter(date) {
    let fecha = new Date(date);
    let fecha_str = "";

    var dia = fecha.getDate();
    if (dia < 10) fecha_str += "0" + dia;
    else fecha_str += dia;

    fecha_str += "/";
    var month = fecha.getMonth();
    if (month < 10) fecha_str += "0" + month;
    else fecha_str += month;

    fecha_str += "/";
    var Year = fecha.getFullYear();
    fecha_str += Year;

    return fecha_str;
  },
  FormatPrice(price) {
    let price_ = price.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(',');
    if (price_.length === 1) {
      price_[1] = "00";
    } else if (price_[1].length === 1) {
      price_[1] = price_[1] + "0";
    }
    return price_.join(',');
  },
  FormatDateTime(date) {
    return moment(date).format('DD/MM/YYYY HH:mm');
  },
  FormatDate(date) {
    return moment(date).format('DD/MM/YYYY');
  },
  FormatPriceWithoutDecimals(price){
    return Math.round(price).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  },
  FormatPrice(price) {
    let price_ = price.toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(',');
    if (price_.length === 1) {
      price_[1] = "00";
    } else if (price_[1].length === 1) {
      price_[1] = price_[1] + "0";
    }
    return price_.join(',');
  },
  isHTML(str) {
    let a = document.createElement('div');
    a.innerHTML = str;

    for (var c = a.childNodes, i = c.length; i--; ) {
      if (c[i].nodeType == 1) return true;
    }

    return false;
  },
  getB64FromInputFile(file){
    return new Promise((resolve, reject)=>{
      try{
        let fr = new FileReader();
        fr.onload = (e) => resolve(fr.result);
        fr.readAsDataURL(file);
      }
      catch (e) {
        let fr = new FileReader();
        fr.onload = (e) => reject(fr.result);
        fr.readAsDataURL(file);
      }
    })
  },
  getB64ImageFromInputFile(file){
    return new Promise((resolve, reject)=>{
      try{
        let fr = new FileReader();
        fr.onload = (e) => resolve(fr.result);
        fr.readAsDataURL(file);
      }
      catch (e) {
        let fr = new FileReader();
        fr.onload = (e) => reject(fr.result);
        fr.readAsDataURL(file);
      }
    })
  },
  resizeBase64Img(resize_width, item){
    return new Promise((resolve, reject)=>{
      let reader = new FileReader();
      try {
        //image turned to base64-encoded Data URI.
        reader.name = item.name;//get the image's name
        reader.size = item.size; //get the image's size
        reader.onload = function(event) {
          let img = new Image();//create a image
          img.src = event.target.result;//result is base64-encoded Data URI
          img.name = event.target.name;//set name (optional)
          img.size = event.target.size;//set size (optional)
          img.onload = function(el) {
            let elem = document.createElement('canvas');//create a canvas
            //scale the image to predefined width (resize_width) and keep aspect ratio
            let scaleFactor = (el.target.width > resize_width) && (((img.size / 1024) / 1024) > 4) ? (resize_width / el.target.width) : 1;
            elem.width = resize_width;
            elem.height = el.target.height * scaleFactor;
            //draw in canvas
            let ctx = elem.getContext('2d');
            ctx.drawImage(el.target, 0, 0, elem.width, elem.height);
            //get the base64-encoded Data URI from the resize image
            let srcEncoded = ctx.canvas.toDataURL(el.target, 'image/png', 0);
            //reolve new data
            resolve(srcEncoded);
          }
        };
        reader.readAsDataURL(item);
      } catch (e) {
        let fr = new FileReader();
        fr.onload = (e) => reject(fr.result);
        fr.readAsDataURL(item);
      }
    })
  },
  isValidCUITCUIL(cuit){
    try {
  		cuit = cuit.replace("-", "");

      if (cuit.length != 11) return false;

      let base = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
      let aux = 0;
      for (let i = 0; i < 10; i++) aux += parseInt(cuit.charAt(i)) * base[i];

      aux = 11 - (aux - (parseInt(aux / 11) * 11));

      if (aux == 11) aux = 0;
      if (aux == 10) aux = 9;

      return aux == parseInt(cuit.charAt(10));
    } catch (e) {
      return false;
    }
	},
  isValidDNI(dni){
    try {
      if (dni.length < 7 || dni.length > 9) return false;
      return Number.isInteger(parseInt(dni));
    } catch (e) {
      return false;
    }
  },
  calcularIncrementoPorcentual(porcentajeBase, porcentajeIncremento=0, ...resto){
    let PorcentajeRecargo = 0;
    try{
      PorcentajeRecargo = porcentajeBase;
      PorcentajeRecargo = 1 + (PorcentajeRecargo / 100);
      PorcentajeRecargo = PorcentajeRecargo * (1 + (porcentajeIncremento/100));
      PorcentajeRecargo = (PorcentajeRecargo - 1) * 100;
      PorcentajeRecargo = PorcentajeRecargo.toFixed(2);
      return (resto.length > 0 ? this.calcularIncrementoPorcentual(PorcentajeRecargo, ...resto) : PorcentajeRecargo);
    } catch (e) {
      PorcentajeRecargo = 0;
    }
    return PorcentajeRecargo;
  },
  calcularDecrementoPorcentual(porcentajeBase, porcentajeDecremento=0, ...resto){
    let PorcentajeDescuento = 0;
    try{
      PorcentajeDescuento = porcentajeBase;
      PorcentajeDescuento = 1 - (PorcentajeDescuento/100);
      PorcentajeDescuento = PorcentajeDescuento * (1 - (porcentajeDecremento / 100));
      PorcentajeDescuento = (1 - PorcentajeDescuento) * 100;
      PorcentajeDescuento = PorcentajeDescuento.toFixed(2);
      return (resto.length > 0 ? this.calcularDecrementoPorcentual(PorcentajeDescuento, ...resto) : PorcentajeDescuento);
    } catch (e) {
      PorcentajeDescuento = 0;
    }
    return PorcentajeDescuento;
  },
}



// WEBPACK FOOTER //
// ./src/functions/functions.js